import { CreateSpineResources, Safe, Scale, Size,MyPIXIContainer } from "../../../MyHelpers";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { Resourceful } from "../../../ResourceManager/Resourceful";
import * as PIXI from "pixi.js";
import { Settings } from "../../../Settings";
import { SpineResource } from "../../../ResourceManager/SpineResource";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { ISkeletonData, Spine } from "../../../PixiSpineRuntime";
import gsap from "gsap";
import { JackpotProperties } from "../../../JackpotProperties";
import { children, element } from "svelte/internal";
import { JackpotLevel } from "../../../api";
import { el } from "date-fns/locale";

export class AwardJPShowElemntPIXAPP {

    protected award: Spine = null;
    protected spinSpineJson: ISkeletonData = null;
    //protected viewPIXIAPP : PIXI.Container = null;  
    //protected animBigFallingAwards: gsap.core.Timeline = null;
    //protected animSmallFallingAwards: gsap.core.Timeline = null;
    constructor(spinSpineJson: ISkeletonData){
        this.spinSpineJson = spinSpineJson;       
    }

    public ViewPIXIAPP(){
        return null
    }

    protected awardDimmondSpine : Spine [] = []

    protected ScaleRandom(){        
        return  parseFloat((0.5 + Math.random()).toFixed(2));
    }

    protected elementsLengt : number = 25;
    protected SmalAwardScale : number = 1;
    protected animating = false;

    public IsAnimating(): boolean {
        return this.animating;
    }

    public ResizeOverlay(oldWidth: number, oldHeight: number, newWidth: number, newHeight: number): void {
        if (this.awardDimmondSpine.length === 0 || oldWidth < 1 || oldHeight < 1 || newWidth < 1 || newHeight < 1) {
            return;
        }
        if (oldWidth === newWidth && oldHeight === newHeight) {
            return;
        }

        const scaleX = newWidth / oldWidth;
        const scaleY = newHeight / oldHeight;
        const wasAnimating = this.animating;

        gsap.killTweensOf(this.awardDimmondSpine);
        this.awardDimmondSpine.forEach((award) => {
            award.x *= scaleX;
            const normalizedY = ((award.y % oldHeight) + oldHeight) % oldHeight;
            award.y = normalizedY * scaleY;
        });

        if (wasAnimating) {
            this.StartAnim(newHeight);
        }
    }

    public CreatePIXIAPP(view : PIXI.Container, boundsWidth: number = Settings.ScreenWidth, boundsHeight: number = Settings.ScreenHeight * Settings.Screens) {
        this.awardDimmondSpine = [];       
        //let sizeSpine = new Size(0,0);
        for (let  i = 0; i < this.elementsLengt; i++) {
            let award = CreateSpineResources(this.spinSpineJson);
            award.name = "AwardJPShowElemntPIXAPP";
            //award.state.setAnimation(0, "animation", true);                                    
            //award.tint = new PIXI.Color( JackpotProperties[Settings.JackpotDisplayType].jp3.color).toNumber();
            award.x = Math.random() * boundsWidth;
            award.y = Math.random() * boundsHeight;
            //award.alpha = Math.random() * 0.5 + 0.5;
            let scale = this.ScaleRandom();
            //console.log("Scale:",scale);
            award.scale.set(Scale.XY(scale));          
            award.pivot.set(award.width/2 , award.height/2);
            //var angle = (Math.random() * 90 - 45); // rango [-45, 45]            
            award.rotation = (Math.random() * 90 - 45) * Math.PI / 180;
            view.addChild(award);     
            this.awardDimmondSpine.push(award);   
            award.state.timeScale = scale;     
            award.renderable = false;
            award.visible = false;   
            scale = null;    
        }


        //let smallAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x < 1);
        //let bigAwardScale = this.awardDimmondSpine.filter(ele=>ele.scale.x > 1);              

        // Animate the rain sprites using GSAP

        // this.animSmallFallingAwards = gsap.timeline({ paused: true});             
    }

    public SetSkin(jp: JackpotLevel) {
        this.awardDimmondSpine.forEach(element => {
            let lowerSideTextrues = element.children.filter(elementchild => {
                if (elementchild.name.includes("lower-side") || elementchild.name.includes("upper-side") || elementchild.name.includes("top")) return elementchild
                return null;
            });

            lowerSideTextrues.forEach(ele => {
                let color = new PIXI.Color(JackpotProperties[Settings.JackpotDisplayType][jp].color).toRgb();
                (element as Spine).skeleton.findSlot(ele.name).color.set(color.r, color.g, color.b, 1);
            });
            lowerSideTextrues = [];
        })        
    }

    public Destroy() {        
        this.animating = false;
        // gsap.killTweensOf(this.awardDimmondSpine);
        // gsap.killTweensOf(this.animSmallFallingAwards);

        // if (this.animSmallFallingAwards) {
        //     this.animSmallFallingAwards.kill();
        //     this.animSmallFallingAwards = null;
        // }
        gsap.killTweensOf(this.awardDimmondSpine);
        this.awardDimmondSpine?.forEach((element, i) => {
            gsap.killTweensOf(element);
            this.destroySpine(element);
            this.awardDimmondSpine[i] = null;
        });

        this.awardDimmondSpine = [];
       
    }

    protected destroySpine(spine: Spine | null) {
        if (!spine) return;

       
        spine.parent.removeChild(spine);
        
        spine.state?.clearListeners();
        spine.state?.clearTracks();
        spine.removeAllListeners();

        spine?.skeleton?.setToSetupPose();
        gsap.killTweensOf(spine);


        spine.destroy({ children: true, texture: false, baseTexture: true });

        // Elimina referencias Spine → Skeleton → State
        spine.skeleton = null;
        spine.state = null;
        spine.stateData = null;
        spine.spineData = null;

        // Si lo almacenaste en algún lado, elimínalo de ahí también
        // Por ejemplo:
        // spinePool.splice(spinePool.indexOf(spine), 1);

        spine = null;
    }

    public StartAnim(boundsHeight: number = Settings.ScreenHeight * Settings.Screens){
        //this.viewPIXIAPP.visible = true;
        //this.viewPIXIAPP.renderable = true;
        this.animating = true;
        gsap.killTweensOf(this.awardDimmondSpine);
        this.awardDimmondSpine.forEach(element=>{
            element.visible = true;
            element.renderable = true;
            element.state.setAnimation(0, "animation", true);
            element.state.setAnimation(1, "animationSparks", true);                                        
        });
        //this.animBigFallingAwards.play(); 
        //this.animSmallFallingAwards.play(); 
        gsap.to(this.awardDimmondSpine, {
            duration: 30,
            ease: "none",
            y: "+=" + boundsHeight,
            modifiers: {
                y: function (y) {
                    const nextY = parseFloat(y);
                    return (((nextY % boundsHeight) + boundsHeight) % boundsHeight).toString();
                },
            },
            repeat: -1,
        });      
    }

    public StopAnim(){        
        //this.animSmallFallingAwards.pause();    
        //this.animBigFallingAwards.pause();  
        this.animating = false;
        gsap.killTweensOf(this.awardDimmondSpine);
    }
}


export class AwardJPShowPIXAPP implements Resourceful {
    protected viewPIXIAPP : PIXI.Container = null;    
    constructor() {        
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        let bonusResorucesSpine : string = `${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine`;
		//preload spine
		resourceManager.AddGlobal(new SpineResource(`${bonusResorucesSpine}/AwardJPSPine/AwardJPSPine.json`, ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineSpine`)));
    }

    protected AwardJPSPineJson: ISkeletonData = null;
    protected awardElements : AwardJPShowElemntPIXAPP = null;
    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        let skeletonData = resourceManager.Get<SpineResource>(ResourceIdentifier.Global.ScopedResourceName(`AwardJPSPineSpine`)).skeletonData;
        this.awardElements = new AwardJPShowElemntPIXAPP(skeletonData);
    }

    protected textureBackagroundContainer : PIXI.Sprite = null;
    protected overlayBounds: { width: number; height: number } = null;
    public CreatePIXIAPP(showBackground: boolean = true, coverFullScreen: boolean = false){
        this.overlayBounds = {
            width: coverFullScreen ? window.innerWidth : Settings.ScreenWidth,
            height: coverFullScreen ? window.innerHeight : Settings.ScreenHeight * Settings.Screens,
        };
        this.viewPIXIAPP = new MyPIXIContainer("AwardJPShowPIXAPP-Container");
        
        this.viewPIXIAPP.name = "AwardJPShowContainerPIXIAPP";
        this.viewPIXIAPP.visible = false;
        this.viewPIXIAPP.renderable = false;
        if (showBackground) {
            this.textureBackagroundContainer = new PIXI.Sprite(PIXI.Texture.WHITE);
            this.textureBackagroundContainer.width = this.overlayBounds.width;
            this.textureBackagroundContainer.height = this.overlayBounds.height;
            this.textureBackagroundContainer.tint = "black";
            this.viewPIXIAPP.addChild(this.textureBackagroundContainer);
        }
        this.awardElements.CreatePIXIAPP( this.viewPIXIAPP, this.overlayBounds.width, this.overlayBounds.height);
        //this.viewPIXIAPP.addChild(this.awardElements.ViewPIXIAPP());        
    }

    public ViewPIXIAPP() : PIXI.Container{
        return this.viewPIXIAPP;
    }
    
    public SetSkin(jp: JackpotLevel){
        this.awardElements.SetSkin(jp);
    }

    public Destroy(){
        if(!this.viewPIXIAPP)return
        gsap.killTweensOf(this.viewPIXIAPP);
        this.textureBackagroundContainer?.removeFromParent();
        this.textureBackagroundContainer?.destroy({children : true , texture : false , baseTexture : true});
        this.textureBackagroundContainer = null;
        this.awardElements?.Destroy();   
        this.viewPIXIAPP?.removeFromParent();                       
        this.viewPIXIAPP?.destroy(true);                       
        this.viewPIXIAPP = null;
    }

    public StartAnim(){
        this.awardElements.StartAnim(this.overlayBounds?.height);
    }
    
    public StopAnim(){
        this.awardElements.StopAnim();
    }

    public ResizeOverlay(width: number, height: number): void {
        if (!this.viewPIXIAPP || width < 1 || height < 1) {
            return;
        }

        const previousBounds = this.overlayBounds ?? { width, height };
        if (previousBounds.width === width && previousBounds.height === height) {
            return;
        }

        this.awardElements?.ResizeOverlay(previousBounds.width, previousBounds.height, width, height);

        this.overlayBounds = { width, height };

        if (this.textureBackagroundContainer) {
            this.textureBackagroundContainer.width = width;
            this.textureBackagroundContainer.height = height;
        }

        this.viewPIXIAPP.position.set(0, 0);
        this.viewPIXIAPP.scale.set(1);
    }
}